// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"ae41e693cbc14452","836":"35d1117c428f55bb"}[chunkId] + ".css";
};